// src/data/siteLocations.js

// Location coordinates
export const siteCoordinates = {
  "Rajasthan": { 
    lat: 27.3389, 
    lon: 73.4347
  },
};
  
// Site details
export const siteDetails = {
  "AXON": {
    location: "Rajasthan",
    coordinates: siteCoordinates["Rajasthan"]
  },
};

export const getSiteByCode = (siteCode) => {
  return siteDetails[siteCode] || null;
};
